/* Accessible, event-delegated size-chart modal.
   Stable outside <variant-selects>, so it survives variant re-rendering.
*/
(function () {
  var openModal = null;
  var lastOpener = null;
  var previousOverflow = '';

  function focusableElements(modal) {
    var selector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var elements = [];

    function collect(root) {
      elements = elements.concat(Array.from(root.querySelectorAll(selector)));
      root.querySelectorAll('*').forEach(function (element) {
        if (element.shadowRoot) collect(element.shadowRoot);
      });
    }

    collect(modal);
    return elements.filter(function (element) {
      return !element.hidden && element.getClientRects().length > 0;
    });
  }

  function deepActiveElement() {
    var active = document.activeElement;
    while (active && active.shadowRoot && active.shadowRoot.activeElement) {
      active = active.shadowRoot.activeElement;
    }
    return active;
  }

  function open(id, opener) {
    var modal = document.getElementById(id);
    if (!modal) return;

    if (openModal && openModal !== modal) close();

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    lastOpener = opener || document.activeElement;
    previousOverflow = document.body.style.overflow;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    openModal = modal;
    lastOpener?.setAttribute('aria-expanded', 'true');

    var focusables = focusableElements(modal);
    (focusables[0] || modal.querySelector('[role="dialog"]'))?.focus();
  }

  function close() {
    if (!openModal) return;

    openModal.hidden = true;
    document.body.style.overflow = previousOverflow;
    lastOpener?.setAttribute('aria-expanded', 'false');
    lastOpener?.focus();
    openModal = null;
    lastOpener = null;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ct-sizechart-open]');
    if (opener) {
      event.preventDefault();
      open(opener.getAttribute('data-ct-sizechart-open'), opener);
      return;
    }

    if (event.target.closest('[data-ct-sizechart-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusables = focusableElements(openModal);
    if (!focusables.length) {
      event.preventDefault();
      openModal.querySelector('[role="dialog"]')?.focus();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = deepActiveElement();
    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
